<template>
	<div class="faction-status">
		<span class="status-label status-hostile">HOSTILE</span>
		<div class="status-track">
			<div
				v-for="seg in segments"
				:key="seg.value"
				class="status-segment"
				:class="[seg.zone, { current: seg.value === value }]"
			>
				<div v-if="seg.value === value" class="status-marker"></div>
			</div>
		</div>
		<span class="status-label status-allied">ALLIED</span>
	</div>
</template>

<script>
export default {
	props: {
		value: { type: Number, default: 0 },
	},
	computed: {
		segments() {
			const segs = [];
			for (let i = -4; i <= 4; i++) {
				let zone = "neutral";
				if (i < 0) zone = "hostile";
				else if (i > 0) zone = "allied";
				segs.push({ value: i, zone });
			}
			return segs;
		},
	},
};
</script>

<style scoped>
.faction-status {
	display: flex;
	align-items: center;
	gap: 0.5em;
}

.status-label {
	font-family: "Share Tech Mono", monospace;
	font-size: 10px;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	flex-shrink: 0;
}

.status-hostile {
	color: #7a1c2e;
}

.status-allied {
	color: #3b7a57;
}

.status-track {
	display: flex;
	flex-direction: row;
	gap: 2px;
	flex: 1;
}

.status-segment {
	flex: 1;
	height: 16px;
	border-radius: 1px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
}

.status-segment.hostile {
	background: #7a1c2e;
	opacity: 0.25;
}

.status-segment.neutral {
	background: #7a7a90;
	opacity: 0.25;
}

.status-segment.allied {
	background: #3b7a57;
	opacity: 0.25;
}

.status-segment.current {
	opacity: 1;
	border: 1px solid #b8973a;
}

.status-marker {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 8px;
	height: 8px;
	background: #b8973a;
	border-radius: 50%;
	box-shadow: 0 0 6px 2px rgba(184, 151, 58, 0.6);
	z-index: 1;
}
</style>
